var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:(_vm.BackGroundColor)},[_c('v-main',[_c('div',{staticClass:"post"},[_c('h1',{staticClass:"mt-10"},[_vm._v("post")]),_c('editor',{attrs:{"api-key":"2a8jyeuhltv0bq3alulb9uzo2tlgbb5q2b827iek63ejo66i","init":{
          height: 500,
          menubar: true,
          plugins: [
            'advlist autolink lists link image charmap print preview anchor',
            'searchreplace visualblocks code fullscreen',
            'insertdatetime media table paste code help wordcount',
          ],
          toolbar:
            'undo redo | formatselect | bold italic backcolor | \
         alignleft aligncenter alignright alignjustify | \
         bullist numlist outdent indent | removeformat | help',
        }}})],1),_c('v-btn',{on:{"click":_vm.submit}},[_vm._v("제출")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.postValue)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }